import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Gift, Heart, Sparkles, Users } from 'lucide-react';
import { Button } from '@/components/ui/button';

const LOGO_URL = "/logo.png";

const AboutPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen">
      {/* Header */}
      <div className="glass-card mx-4 my-6 p-6">
        <div className="max-w-6xl mx-auto">
          <div className="flex items-center justify-between">
            <img 
              src={LOGO_URL}
              alt="My Wishlist Logo" 
              className="h-16 w-auto cursor-pointer"
              onClick={() => navigate('/home')}
            />
            <Button
              onClick={() => navigate('/home')}
              variant="ghost"
              className="gap-2"
            >
              <ArrowLeft className="w-4 h-4" />
              Back to Home
            </Button>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 py-12">
        <div className="glass-card p-12 space-y-8">
          <h1 className="text-4xl sm:text-5xl font-extrabold text-gray-800 mb-6">
            About My Wishlist
          </h1>

          <p className="text-xl text-gray-700 leading-relaxed">
            My Wishlist is designed for one simple purpose:
            <br />
            <strong>Make gifting joyful, meaningful, and still surprising.</strong>
          </p>

          <p className="text-lg text-gray-600 leading-relaxed">
            Most birthdays and celebrations end up with duplicate gifts, unused presents, or confusion.
            We fix that — while keeping the magic of surprise alive.
          </p>

          {/* What We Believe */}
          <div className="pt-8">
            <h2 className="text-3xl font-bold text-gray-800 mb-6">What We Believe</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="flex items-start gap-4">
                <div className="text-4xl">🎁</div>
                <div>
                  <h3 className="font-bold text-lg text-gray-800 mb-1">Useful gifts = happy celebrations</h3>
                  <p className="text-gray-600">Everyone deserves gifts they'll actually use and love</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="text-4xl">🎉</div>
                <div>
                  <h3 className="font-bold text-lg text-gray-800 mb-1">Surprises = joy</h3>
                  <p className="text-gray-600">The mystery of who gave what adds magic to every gift</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="text-4xl">💖</div>
                <div>
                  <h3 className="font-bold text-lg text-gray-800 mb-1">Thoughtful gifting should be simple</h3>
                  <p className="text-gray-600">No stress, no confusion, just pure joy</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="text-4xl">📱</div>
                <div>
                  <h3 className="font-bold text-lg text-gray-800 mb-1">Technology should make life easier</h3>
                  <p className="text-gray-600">Simple, intuitive tools for everyone</p>
                </div>
              </div>
            </div>
          </div>

          {/* Our Mission */}
          <div className="pt-8">
            <h2 className="text-3xl font-bold text-gray-800 mb-4">Our Mission</h2>
            <p className="text-xl text-gray-700 leading-relaxed">
              To create the <strong>most delightful gifting experience</strong> for both receivers and givers.
            </p>
          </div>

          {/* CTA */}
          <div className="pt-8 text-center">
            <Button
              onClick={() => navigate('/dashboard')}
              size="lg"
              style={{background: 'linear-gradient(135deg, #FF3E96 0%, #FF1744 100%)'}}
              className="text-white px-12 py-6 rounded-full text-xl font-bold shadow-xl"
            >
              Start Your Wishlist
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;